import { UndefinedInitialDataOptions, useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { EditBrandTransFields } from '@pages/EditBrand/types';
import { editBrandTranslations } from '@pages/EditBrand/translations';
import { useMyQuery } from './useMyQuery';
import { useStore } from './useStore';
import { useMyTranslations } from './useMyTranslations';
import { useMemo } from 'react';

export function useGetBrandData(text?: string) {
  const {
    brandsStore: { getBrand, brand },
  } = useStore();

  const { brandId } = useParams();

  const { isFetching } = useMyQuery({
    queryKey: ['getBrand'],
    queryFn: () => brandId && getBrand(brandId),
    enabled: !!brandId && !brand,
    staleTime: 0,
  });

  const { t } = useMyTranslations<Extract<EditBrandTransFields, 'brand'>>([
    editBrandTranslations.name,
  ]);

  const fullText = useMemo(
    () => (brand ? `${text || t('brand')} "${brand?.name}"` : ''),
    [brand?.name, text]
  );

  return { isFetching, text: fullText };
}
